"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Workspace = void 0;
const Client_1 = require("../resources/groups/client/Client");
const Client_2 = require("../resources/invites/client/Client");
const Client_3 = require("../resources/members/client/Client");
const Client_4 = require("../resources/resources/client/Client");
class Workspace {
    constructor(_options = {}) {
        this._options = _options;
    }
    get groups() {
        var _a;
        return ((_a = this._groups) !== null && _a !== void 0 ? _a : (this._groups = new Client_1.Groups(this._options)));
    }
    get invites() {
        var _a;
        return ((_a = this._invites) !== null && _a !== void 0 ? _a : (this._invites = new Client_2.Invites(this._options)));
    }
    get members() {
        var _a;
        return ((_a = this._members) !== null && _a !== void 0 ? _a : (this._members = new Client_3.Members(this._options)));
    }
    get resources() {
        var _a;
        return ((_a = this._resources) !== null && _a !== void 0 ? _a : (this._resources = new Client_4.Resources(this._options)));
    }
}
exports.Workspace = Workspace;
